import validator from "validator";
//@ts-ignore
import Moengage from "@moengage/web-sdk";
import parse from "html-react-parser";
import {
  browserName,
  fullBrowserVersion,
  isDesktop,
  isMobile,
  isMobileOnly,
  osName,
  osVersion,
  mobileModel,
  mobileVendor,
} from "react-device-detect";
import config from "../../commons/config";
import { getSessionStorage, setSessionStorage } from "../../util/storageUtil";
import { getAppConfig } from "./appConfigHelper";
import {
  flatAndMapEventData,
  mapEventData,
} from "../../util/analytics/cdp/Constant";

import Lounge_fallback from "../../assets/images/airportDimensions/LoungeIcon_Fallback.svg";
import FNB_fallback from "../../assets/images/airportDimensions/FNBIcon_fallback.svg";
import Meeting_fallback from "../../assets/images/airportDimensions/MeetingIcon.svg";
import shower_fallback from "../../assets/images/airportDimensions/ShowerIcon_Fallback.svg";
import ProductFallbackImg from "../../pages/edpFSTR/assets/Fallback Images/product-fallback-medium.svg";
import Luminance_fallback from "../../assets/images/airportDimensions/Luminescence_fallback.svg";
import meetingroom_fallback from "../../assets/images/airportDimensions/MeetingRoom_fallback.svg";
import motherroom_fallback from "../../assets/images/airportDimensions/MothersRoom_fallback.svg";
import waiting_fallback from "../../assets/images/airportDimensions/Waiting_Fallback.svg";
import moment from "util/momentWrapper";
import ReactGA from "react-ga4";

const options = {
  autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
  debug: false, // enable logs
};

const Util = {
  isWebView() {
    // return true;

    var standalone = window.navigator.standalone,
      userAgent = window.navigator.userAgent.toLowerCase(),
      safari = /safari/.test(userAgent),
      ios = /iphone|ipod|ipad/.test(userAgent);
    if (ios) {
      if (!standalone && safari) {
        // Safari
      } else if (!standalone && !safari) {
        // iOS webview
        return true;
      }
    } else {
      if (userAgent.includes("wv")) {
        // Android webview
        return true;
      } else {
        // Chrome
      }
    }
    return false;
  },
  getSlug(pathName) {
    let slug;
    if (pathName) {
      slug = pathName.split("/")[pathName.split("/").length - 1];
    } else {
      slug = "";
    }
    return slug;
  },
  isEmailValid(email) {
    let res;
    if (validator.isEmail(email)) {
      res = true;
    } else {
      res = false;
    }
    return res;
  },
  googlePixel() {
    if (typeof window.gtag !== "undefined") {
      window.gtag("config", "AW-315543967");
      window.gtag("track", "PageView");
    }
  },
  fnBrowserDetect() {
    let userAgent = navigator.userAgent;
    if (userAgent.match(/chrome|chromium|crios/i)) {
      return "chrome";
    } else if (userAgent.match(/firefox|fxios/i)) {
      return "firefox";
    } else if (userAgent.match(/safari/i)) {
      return "safari";
    } else if (userAgent.match(/opr\//i)) {
      return "opera";
    } else if (userAgent.match(/edg/i)) {
      return "edge";
    } else {
      return "No browser detection";
    }
  },
  getUrlParams(t) {
    var r = {};
    if (t) {
      let i = t.split("?")[1];
      if (i) {
        if (i.includes("%26")) {
          i = i.replaceAll("%26", "&");
        }
        const t = i.split("&");
        t &&
          t.forEach((t) => {
            var i = t.split("=");
            r[i[0]] = i[1];
          });
      }
    }
    return r;
  },
  chatBot(url, path) {
    let corover = document.getElementById("corover-cb-widget");
    let floatingAvatar = document.getElementById("floating-avatar");
    let coroverChatbox = document.getElementById("corover-chatbox");
    document.addEventListener("click", () => {
      // console.log('Floating avatar clicked!');
      Util.sendMessageToReactNative("MICROPHONE_PERMISSION_CHECK");
    });

    if (path === "/") {
      let script = document.createElement("script");
      script.src = url;
      script.type = "text/javascript";
      script.id = "chatbot";

      if (document.getElementById("chatbot")) {
        if (corover) corover.style.visibility = "visible";
        if (floatingAvatar) floatingAvatar.style.visibility = "visible";
        if (coroverChatbox) coroverChatbox.style.visibility = "visible";
      } else {
        document.getElementsByTagName("head")[0].appendChild(script);
      }
    } else {
      if (corover) corover.style.visibility = "hidden";
      if (floatingAvatar) floatingAvatar.style.visibility = "hidden";
      if (coroverChatbox) coroverChatbox.style.visibility = "hidden";
    }
  },
  isDesktop() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    const mobileRegex =
      /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
    if (mobileRegex.test(userAgent.toLowerCase())) {
      return false;
    }

    return true;
  },
  isMobile() {
    // Returns true is user is using mobile device
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobile =
      /android|iphone|ipad|ipod|blackberry|windows phone|webos/i.test(
        userAgent,
      );
    return isMobile;
  },
  isMobileBrowser() {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      )
    ) {
      return true;
    } else {
      return false;
    }
  },
  isIosWebView() {
    let standalone = window.navigator.standalone,
      userAgent = window.navigator.userAgent.toLowerCase(),
      safari = /safari/.test(userAgent),
      ios = /iphone|ipod|ipad/.test(userAgent);
    if (ios) {
      if (!standalone && safari) {
        // Safari
      } else if (!standalone && !safari) {
        // iOS webview
        return true;
      }
    }
    return false;
  },
  isAndroidWebView() {
    let userAgent = window.navigator.userAgent.toLowerCase(),
      ios = /iphone|ipod|ipad/.test(userAgent);
    if (!ios) {
      if (userAgent.includes("wv")) {
        // Android webview
        return true;
      } else {
        // Chrome
      }
    }
    return false;
  },
  getUserAgentData() {
    let browser = browserName || "";

    let ref = "";
    if (isMobileOnly) ref = `Mobile ${browser}`;
    else if (isMobile) ref = `Tablet ${browser}`;
    else if (isDesktop) ref = `Desktop ${browser}`;

    let channel = "";
    const platform = getAppConfig("platform");
    if (platform?.toLowerCase() === "marketplace") {
      channel = "Web Application";
    } else {
      if (this.isIosWebView()) channel = "iOS Mobile App";
      else if (this.isAndroidWebView()) channel = "Android Mobile App";
      else channel = "Web Application";
    }

    const qParams = `?channel=${channel}&ref=${ref}`;
    return qParams;
  },

  getUsermetaData() {
    const osname = osName || "";
    const osversion = osVersion || "";
    const browsername = browserName || "";
    const browserversion = fullBrowserVersion || "";

    const metadata = {
      os: `${osname}|${osversion}`,
      platform: `${browsername}|${browserversion}`,
    };

    // Campaign Source: Passing as Agent (temporary)
    const campaignId = getSessionStorage("campaignId");
    if (campaignId) {
      metadata.agent = campaignId;
    }
    return metadata;
  },

  triggerMoEngageEvent(
    eventName,
    data,
    additionalData = {},
    flattenItems = false,
    locationData = {},
    shouldSendToGA = true,
  ) {
    try {
      const moEngageEnabled = getAppConfig("MOENGAGE_ENABLED");
      const location = localStorage.getItem("appConfig");
      const selectedAirport = localStorage.getItem("selectedAirport");
      const selectedTimezone = localStorage.getItem("selectedTimezone");
      const selectedStore = localStorage.getItem("selectedStore");
      const userData = localStorage.getItem("userData");
      if (location) {
        const parsedLocation = JSON.parse(location);
        const user = JSON.parse(userData);
        const decryptedUserId = user?.data?.userId
          ? atob(user.data.userId)
          : "";
        locationData = {
          xAppLocationCode: parsedLocation?.xAppLocationCode || "",
          airportCode: selectedAirport || "",
          timezone: selectedTimezone || "",
          loungeCode: selectedStore || "",
          userId: decryptedUserId || "",
          timestamp: moment().format("YYYY-MM-DD HH:mm:ss"),
          ...(getSessionStorage("utm_source") && {
            utm_source: getSessionStorage("utm_source"),
          }),
        };
      }

      if (moEngageEnabled) {
        let eventData = {};
        if (flattenItems) {
          eventData = flatAndMapEventData(eventName, data);
        } else {
          eventData = mapEventData(eventName, data);
        }
        eventData = { ...eventData, ...additionalData, ...locationData };

        if (Object.keys(eventData).length === 0) {
          eventData = data;
        }

        if ("lmsmemberid" in eventData && !eventData.lmsmemberid) {
          eventData.lmsmemberid = "no-id";
        }

        if (window.ReactNativeWebView) {
          let reactMsg = JSON.stringify({
            msg: eventName,
            data: eventData || {},
            type: "MoEngageEvent",
          });
          window.ReactNativeWebView.postMessage(reactMsg);
        } else {
          Moengage.track_event(eventName, eventData || {});
        }
        // Google Analytics
        if (shouldSendToGA) {
          ReactGA.event(eventName, {
            category: eventName,
            action: eventName,
            label: eventName,
            ...eventData,
          });
        }

        return;
      }
    } catch (e) {
      console.log("Error in triggerMoEngageEvent: ", e);
    }
  },

  identifyMoEngageUser(overrides = {}) {
    try {
      const userData = JSON.parse(localStorage.getItem("userData") || "null");
      const data = userData?.data || {};
      const metadata = userData?.metadata || {};

      const memberId =
        overrides.memberId ??
        metadata?.status?.membership?.loyalty?.mmid ??
        metadata?.status?.membership?.mmid;
      const userId = overrides.userId ?? data.userId;
      const firstName = overrides.firstName ?? data.firstName;
      const lastName = overrides.lastName ?? data.lastName;
      const name =
        overrides.name ||
        data.fullName ||
        [firstName, lastName].filter(Boolean).join(" ");
      const extraAttributes = {
        dob: data.dob,
        nationality: data.nationality,
        ...overrides.extraAttributes,
      };

      const setAttributes = () => {
        Moengage.add_user_attribute("lmsmemberid", memberId || "no-id");
        if (name) Moengage.add_user_name(name);
        if (firstName) Moengage.add_first_name(firstName);
        if (lastName) Moengage.add_last_name(lastName);
        if (userId) Moengage.add_user_attribute("userId", userId);
        Object.entries(extraAttributes).forEach(([key, value]) => {
          if (value !== undefined && value !== null && value !== "") {
            Moengage.add_user_attribute(key, value);
          }
        });
      };

      Promise.resolve(Moengage.add_unique_user_id(memberId || "no-id")).then(
        setAttributes
      );
    } catch (e) {
      console.log("Error in identifyMoEngageUser: ", e);
    }
  },

  sendMessageToReactNative(msg, data) {
    try {
      if (msg.toLowerCase().includes("moengage")) {
        const config = localStorage.getItem("appConfig");
        const parsedConfig = JSON.parse(config);
        let message = msg;

        if (msg.includes("moengage-user")) {
          message = msg.slice(14);
        } else {
          message = msg.slice(9);
        }

        if (parsedConfig.ENVIRONMENT.toLowerCase().includes("dev")) {
          if (window.ReactNativeWebView) {
            let reactMsg = JSON.stringify({
              msg: msg,
              data: data || {},
            });
            window.ReactNativeWebView.postMessage(reactMsg);
          } else {
            Moengage.track_event(message, data || {});
          }
          return;
        }
      }
      if (window.ReactNativeWebView) {
        if (msg !== undefined) {
          window.ReactNativeWebView.postMessage(msg);
        }
      }
    } catch (e) {}
  },

  triggerGTMConversion(eventName, conversion, data) {
    if (typeof window !== "undefined" && window.gtag) {
      window.gtag(eventName, conversion, data || {});
    }
  },

  htmlParse(data) {
    if (data) return parse(data.split('<div class="raw-html-embed">')[1]);
  },
  checkMarketingPage(slug) {
    if (
      slug === "/bial-marketing-1" ||
      slug === "/bial-marketing-2" ||
      slug === "/bial-marketing-3" ||
      slug === "/bial-marketing-4" ||
      slug === "/bial-marketing-5"
    ) {
      return true;
    } else {
      return false;
    }
  },
  truncatingSentence(str, num) {
    if (str.length <= num) {
      return str;
    }
    return str.slice(0, num) + "...";
  },

  getBookingSource() {
    const platform = getAppConfig("platform");
    if (platform?.toLowerCase() === "marketplace") {
      return `${getAppConfig("BOOKING_SOURCE")}-web`;
    } else {
      if (Util.isAndroidWebView()) {
        return `${getAppConfig("BOOKING_SOURCE")}-android-app`;
      } else if (Util.isIosWebView()) {
        return `${getAppConfig("BOOKING_SOURCE")}-ios-app`;
      } else {
        return `${getAppConfig("BOOKING_SOURCE")}-web`;
      }
    }
  },
  getQrCodeSource(url) {
    let params = Util.getUrlParams(url);
    let source = [];

    if (params["QRCodescancampaign"]) {
      source.push(
        `QRCodescancampaign=${decodeURIComponent(params["QRCodescancampaign"])}`,
      );
    }
    if (params["GAAdCampaign"]) {
      source.push(`GAAdCampaign=${decodeURIComponent(params["GAAdCampaign"])}`);
    }
    if (params["SMAdCampaign"]) {
      source.push(`SMAdCampaign=${decodeURIComponent(params["SMAdCampaign"])}`);
    }
    if (params["utm_source"]) {
      setSessionStorage("utm_source", decodeURIComponent(params["utm_source"]));
    }

    if (source?.length > 0) {
      source = JSON.stringify(source);
      setSessionStorage("qrCodeSource", source);
    }
  },
  getAuthHeaders(category) {
    let region = Intl.DateTimeFormat().resolvedOptions().timeZone;

    let platform = "NA";
    if (this.isWebView()) platform = "App";
    else platform = "Web";

    let os = "NA";
    if (this.isIosWebView()) os = "IOS";
    else if (this.isAndroidWebView()) os = "Android";
    else os = "Web";

    let cat = category || "";
    let deviceName = mobileModel || "";
    let deviceManufacturer = mobileVendor || "";
    let browser = browserName || "";

    let headers = {
      "x-app-region": region,
      "x-app-platform": platform,
      "x-app-category": cat,
      "x-device-name": deviceName,
      "x-device-manufacturer": deviceManufacturer,
      "x-device-operating-system": os,
      "x-device-browser-agent": browser,
    };
    return headers;
  },

  getRootDomain(url) {
    try {
      const { hostname } = new URL(url);
      const parts = hostname.split(".");

      if (parts.length >= 2) {
        return parts.slice(-2).join(".");
      }

      return hostname;
    } catch (err) {
      console.error("Invalid URL:", err);
      return null;
    }
  },

  getBrowserName() {
    const userAgent = navigator.userAgent;

    if (userAgent.includes("Edg")) return "Edge";
    if (userAgent.includes("OPR") || userAgent.includes("Opera"))
      return "Opera";
    if (
      userAgent.includes("Chrome") &&
      !userAgent.includes("Edg") &&
      !userAgent.includes("OPR")
    )
      return "Chrome";
    if (userAgent.includes("Firefox")) return "Firefox";
    if (userAgent.includes("Safari") && !userAgent.includes("Chrome"))
      return "Safari";
    if (userAgent.includes("Trident")) return "Internet Explorer";

    return "Unknown";
  },

  getConstructedUrl(code) {
    const baseUrl = import.meta.env.REACT_APP_SUBDOMAIN_URL || "";
    const url = baseUrl.replace("{{airportCode}}", code?.toLowerCase());
    return url;
  },

  getFallbackImage(type) {
    switch (type) {
      case "lounge":
        return Lounge_fallback;
      case "food and beverages":
        return FNB_fallback;
      case "meeting rooms":
        return Meeting_fallback;
      case "shower":
        return shower_fallback;
      case "luminescence room":
        return Luminance_fallback;
      case "meeting room":
        return meetingroom_fallback;
      case "lululemon studio mirror":
        return motherroom_fallback;
      case "lounge waitlist":
        return waiting_fallback;
      default:
        return ProductFallbackImg;
    }
  },
  getTemplateTwo() {
    return getAppConfig("TEMPLATE_ID")?.toLowerCase() === "templatetwo";
  },
};
export default Util;
